import toast from '@/plugins/izitoast'
import get from 'lodash-es/get'

import { getObj, getAccessToken, getObjPersisted } from '@/utils/SessionStorage'
import { getLocale } from '@/utils/DateTimeService'

/**
 * Get toast error from API response.
 *
 */
export const getToastError = (content) => {
    // if ('development' !== process.env.NODE_ENV) {
    const { response } = content
    console.error(content) // eslint-disable-line no-console
    // let message = []

    // const status = get(content, 'response.status', null)
    const traceId = get(content, 'response.data.traceId', null)
    const traceIdInfo = traceId ? `Problem identifier: ${traceId}` : ''

    return `${response.data.title}: ${response.data.message}. ${traceIdInfo}`
    // return ('string' === typeof (message) && 400 === status) ? message : 'Something went wrong.'
    // }

    // const toastMessage = []
    // if (null == content) return '[Empty Content]'
    // if ('string' === typeof (content)) return content
    // if ('string' === typeof (content.message)) toastMessage.push(content.message)
    // if ('string' === typeof (content.Message)) toastMessage.push(content.Message)
    //
    // if ('object' === typeof content) {
    //     const { response } = content
    //
    //     if (null != response && 'object' === typeof response) {
    //         const { status, statusText, data } = response
    //
    //         if (null != status) toastMessage.push(status)
    //         if (null != statusText) toastMessage.push(statusText)
    //         if (null != data && 'object' === typeof data) {
    //             for (let errorGroup in data) {
    //                 if (Array.isArray(data[errorGroup])) {
    //                     toastMessage.push(data[errorGroup].join('<br />'))
    //                 } else {
    //                     toastMessage.push(data[errorGroup])
    //                 }
    //             }
    //         }
    //     }
    // }
    //
    // // As a catch-all just stringify the response if we get
    // // this far with no message content.
    // if (0 === toastMessage.length) return JSON.stringify(content)
    // return toastMessage.join(' | ')
}

/**
 * Get appropriate response based on success status and
 * environment settings.
 * @param {boolean} isSuccess
 * @param {{ suppressError: boolean }} options
 */
export const responseHandler = (
    isSuccess,
    options = { suppressError: false }
) => (content) => {
    const payload = isSuccess
        ? get(content, 'data')
        : get(content, 'response.data', content)

    const raiseToast = null == options || !options.suppressError
    const type = get(content, 'response.data.type', null)

    if (!isSuccess && raiseToast && get(content, 'response.status', null) !== 401 && !type) toast.error(getToastError(content))

    return {
        isSuccess,
        payload
    }
}

/**
 * Handle success result.
 * @param {*} content
 */
export const successResult = (content) => responseHandler(true)(content)

/**
 * Handle failure result.
 * @param {*} message
 */
export const failureResult = (message) => responseHandler(false)(message)

/**
 * Get bearer token.
 */
export const bearerToken = () => {
    const token = getAccessToken()
    return token
}

/**
 * Get organisation header.
 */
export const getOrganisationHeader = () => {
    const organisationId = localStorage.getItem('activeOrganization')
    const defaultOrganisationId = localStorage.getItem('defaultOrganization')

    if (null == organisationId || defaultOrganisationId === organisationId) return {}
    return {
        'organization': organisationId
    }
}

/**
 * Get child organisations header.
 */
export const getOrganisationSelectionHeader = () => {
    const organisationIds = getObj('organisation-selection')
    if (null == organisationIds) return {}
    return {
        'organisation-selection': organisationIds.map(x => x.value).join()
    }
}

export const getTimeZoneHeader = () => {
    const userTimeZone = getObjPersisted('user_timezone')
    if (null == userTimeZone) return {}
    return {
        'USER-TIMEZONE': userTimeZone
    }
}

export const getLocaleHeader = () => {
    const userLocale = getLocale()
    if (null == userLocale) return {}
    return {
        'USER-LOCALE': userLocale
    }
}
